module.exports = __webpack_public_path__ + "media/application/images/icons/cross_white_chunky-d49b1a23a7cec17d4b46f927d7210063.svg";